import { CustomTable, CustomTableProps } from '@atbay/cyber-components'
import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import { ComponentType } from 'react'

export const TableWrapper = styled('div')`
    margin-bottom: 24px;
`
export const Cell = styled('div')`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 45px;
`

export const StatusCell = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
`

export const ActionsCell = styled('div')`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 45px;
`

export const StyledIntegrationsTable = styled(
    CustomTable as ComponentType<CustomTableProps>
)<{
    theme?: TTheme
}>`
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};

    table {
        overflow: hidden;
        background-color: ${({ theme }) =>
            theme.colors.semantic.backgroundSecondary};
        border-bottom: 1px solid ${({ theme }) => theme.colors.greys[200]};
        border-color: ${({ theme }) => theme.colors.greys[200]};
        border-spacing: 0;
        tr {
            background-color: ${({ theme }) =>
                theme.colors.semantic.backgroundSecondary};
            color: ${({ theme }) => theme.colors.greys[800]};
            height: 45px;
            border-color: ${({ theme }) => theme.colors.greys[200]};
        }
        th {
            height: 45px;
            vertical-align: middle;
        }
    }

    table tr:hover td {
        background-color: ${({ theme }) =>
            theme.colors.semantic.tableHover} !important;
        border-color: ${({ theme }) => theme.colors.semantic.tableHover};
    }
`

export const TooltipContent = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 5px;
`

export const ClickableCell = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isClickable',
})<{ isClickable?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 45px;
    cursor: ${({ isClickable = true }) => (isClickable ? 'pointer' : 'default')};

    * {
        cursor: ${({ isClickable = true }) =>
            isClickable ? 'pointer' : 'default'};
    }
`

export const IssueCountItem = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
        width: 14px;
        height: 14px;
    }
`

export const IssueCountWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`
